module.exports = __webpack_public_path__ + "img/hr-sand-rock-small-07.6a542445.png";